import React from "react";
import PageHeader from "./PageHeader.js";
import SiteFooter from "./SiteFooter.js";
import "./MarketingLayout.css";

/**
 * Wraps marketing/legal pages with shared header and footer.
 * Use for Contact, Overview, Download, Apps, SuccessPage, etc.
 */
export default function MarketingLayout({ children, noFooter = false, flush = false }) {
  return (
    <div className={`marketing-layout${flush ? " marketing-layout--flush" : ""}`}>
      <PageHeader />
      <main id="main-content" className="marketing-layout__main" tabIndex={-1}>
        {children}
      </main>
      {!noFooter && <SiteFooter />}
    </div>
  );
}
